var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDriverIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "driver_icon",
    transform: "translate(0.115 -2108)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1030",
    "data-name": "Rectangle 1030",
    width: 96,
    height: 96,
    rx: 12,
    transform: "translate(-0.115 2108)",
    fill: "#e5f1fb"
  }), /*#__PURE__*/React.createElement("g", {
    id: "local_shipping_black_24dp",
    transform: "translate(21 2129)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3142",
    "data-name": "Path 3142",
    d: "M0,0H54V54H0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3143",
    "data-name": "Path 3143",
    d: "M42.625,13H37V8.5A4.513,4.513,0,0,0,32.5,4H5.5A4.513,4.513,0,0,0,1,8.5V28.75a4.513,4.513,0,0,0,4.5,4.5,6.75,6.75,0,0,0,13.5,0H32.5a6.75,6.75,0,0,0,13.5,0h2.25A2.257,2.257,0,0,0,50.5,31V23.508a4.527,4.527,0,0,0-.9-2.7L44.425,13.9a2.281,2.281,0,0,0-1.8-.9ZM12.25,35.5a2.25,2.25,0,1,1,2.25-2.25A2.257,2.257,0,0,1,12.25,35.5ZM42.625,16.375,47.035,22H37V16.375ZM39.25,35.5a2.25,2.25,0,1,1,2.25-2.25A2.257,2.257,0,0,1,39.25,35.5Z",
    transform: "translate(1.25 5)",
    fill: "#0078d7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDriverIcon);
export default __webpack_public_path__ + "static/media/driver_icon.733a5c8fae50edf71f9867ee6f594a85.svg";
export { ForwardRef as ReactComponent };